import { render, staticRenderFns } from "./PerfilEditarForm.vue?vue&type=template&id=61a0e1f0"
import script from "./PerfilEditarForm.vue?vue&type=script&lang=js"
export * from "./PerfilEditarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports